import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ReportDefinitionWithIcon } from 'types/reports';

import ReportCard from './ReportCard';

interface ReportCategorySectionProps {
  title: string;
  reports: ReportDefinitionWithIcon[];
  onGenerateReport: (report: ReportDefinitionWithIcon) => void;
}

export function ReportCategorySection({
  title,
  reports,
  onGenerateReport,
}: ReportCategorySectionProps) {
  if (reports.length === 0) {
    return null;
  }

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <Chip label={reports.length} size="small" color="primary" />
      </Stack>
      <Grid container spacing={2}>
        {reports.map((report) => (
          <Grid key={report.id} size={{ xs: 12, sm: 6, lg: 4 }}>
            <ReportCard report={report} onGenerate={onGenerateReport} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ReportCategorySection;
